import { ParseKeys } from "i18next";

import enCommon from "../en/common.json";
import enMain from "../en/main.json";
import enSandbox from "../en/sandbox.json";

export const defaultNS = "main";

export const resources = {
  en: {
    main: enMain,
    common: enCommon,
    sandbox: enSandbox,
  },
} as const;

export type I18nKeyType =
  | `main:${ParseKeys<"main">}`
  | `common:${ParseKeys<"common">}`
  | `sandbox:${ParseKeys<"sandbox">}`;
